// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { DuplicatePaymentMethodCheckDTO } from '../models';
import { IsDuplicateResponse } from '../models';
import { OrderAmountRemainingDTO } from '../models';
/**
 * OrdersApi - axios parameter creator
 * @export
 */
export const OrdersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Check for a duplicate payment method on all paid customers related to an order
         * @param {string} id Order Id
         * @param {DuplicatePaymentMethodCheckDTO} duplicatePaymentMethodCheckDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicatePaymentMethodCheck(id: string, duplicatePaymentMethodCheckDTO: DuplicatePaymentMethodCheckDTO, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling duplicatePaymentMethodCheck.');
            }
            // verify required parameter 'duplicatePaymentMethodCheckDTO' is not null or undefined
            if (duplicatePaymentMethodCheckDTO === null || duplicatePaymentMethodCheckDTO === undefined) {
                throw new RequiredError('duplicatePaymentMethodCheckDTO','Required parameter duplicatePaymentMethodCheckDTO was null or undefined when calling duplicatePaymentMethodCheck.');
            }
            const localVarPath = `/v2/orders/{id}/duplicate-payment-method-check`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"DuplicatePaymentMethodCheckDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(duplicatePaymentMethodCheckDTO !== undefined ? duplicatePaymentMethodCheckDTO : {}) : (duplicatePaymentMethodCheckDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets the amount remaining on an order
         * @param {string} id Order id
         * @param {boolean} includeInterest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAmountRemaining(id: string, includeInterest: boolean, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getAmountRemaining.');
            }
            // verify required parameter 'includeInterest' is not null or undefined
            if (includeInterest === null || includeInterest === undefined) {
                throw new RequiredError('includeInterest','Required parameter includeInterest was null or undefined when calling getAmountRemaining.');
            }
            const localVarPath = `/v2/orders/{id}/amount-remaining`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (includeInterest !== undefined) {
                localVarQueryParameter['includeInterest'] = includeInterest;
            }


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrdersApi - functional programming interface
 * @export
 */
export const OrdersApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Check for a duplicate payment method on all paid customers related to an order
         * @param {string} id Order Id
         * @param {DuplicatePaymentMethodCheckDTO} duplicatePaymentMethodCheckDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicatePaymentMethodCheck(id: string, duplicatePaymentMethodCheckDTO: DuplicatePaymentMethodCheckDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<IsDuplicateResponse> {
            const localVarAxiosArgs = OrdersApiAxiosParamCreator(configuration).duplicatePaymentMethodCheck(id, duplicatePaymentMethodCheckDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Gets the amount remaining on an order
         * @param {string} id Order id
         * @param {boolean} includeInterest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAmountRemaining(id: string, includeInterest: boolean, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderAmountRemainingDTO> {
            const localVarAxiosArgs = OrdersApiAxiosParamCreator(configuration).getAmountRemaining(id, includeInterest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * OrdersApi - factory interface
 * @export
 */
export const OrdersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Check for a duplicate payment method on all paid customers related to an order
         * @param {string} id Order Id
         * @param {DuplicatePaymentMethodCheckDTO} duplicatePaymentMethodCheckDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicatePaymentMethodCheck(id: string, duplicatePaymentMethodCheckDTO: DuplicatePaymentMethodCheckDTO, options?: any) {
            return OrdersApiFp(configuration).duplicatePaymentMethodCheck(id, duplicatePaymentMethodCheckDTO, options)(axios, basePath);
        },
        /**
         * Gets the amount remaining on an order
         * @param {string} id Order id
         * @param {boolean} includeInterest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAmountRemaining(id: string, includeInterest: boolean, options?: any) {
            return OrdersApiFp(configuration).getAmountRemaining(id, includeInterest, options)(axios, basePath);
        },
    };
};

/**
 * OrdersApi - interface
 * @export
 * @interface OrdersApi
 */
export interface OrdersApiInterface {
    /**
     * Check for a duplicate payment method on all paid customers related to an order
     * @param {string} id Order Id
     * @param {DuplicatePaymentMethodCheckDTO} duplicatePaymentMethodCheckDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    duplicatePaymentMethodCheck(id: string, duplicatePaymentMethodCheckDTO: DuplicatePaymentMethodCheckDTO, options?: any): AxiosPromise<IsDuplicateResponse>;

    /**
     * Gets the amount remaining on an order
     * @param {string} id Order id
     * @param {boolean} includeInterest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    getAmountRemaining(id: string, includeInterest: boolean, options?: any): AxiosPromise<OrderAmountRemainingDTO>;

}

/**
 * OrdersApi - object-oriented interface
 * @export
 * @class OrdersApi
 * @extends {BaseAPI}
 */
export class OrdersApi extends BaseAPI implements OrdersApiInterface {
    /**
     * Check for a duplicate payment method on all paid customers related to an order
     * @param {string} id Order Id
     * @param {DuplicatePaymentMethodCheckDTO} duplicatePaymentMethodCheckDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    public duplicatePaymentMethodCheck(id: string, duplicatePaymentMethodCheckDTO: DuplicatePaymentMethodCheckDTO, options?: any) {
        return OrdersApiFp(this.configuration).duplicatePaymentMethodCheck(id, duplicatePaymentMethodCheckDTO, options)(this.axios, this.basePath);
    }

    /**
     * Gets the amount remaining on an order
     * @param {string} id Order id
     * @param {boolean} includeInterest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    public getAmountRemaining(id: string, includeInterest: boolean, options?: any) {
        return OrdersApiFp(this.configuration).getAmountRemaining(id, includeInterest, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for OrdersApi
 * Import individual functions for optimal bundle size
 */
/**
 * Check for a duplicate payment method on all paid customers related to an order
 * @param {string} id Order Id
 * @param {DuplicatePaymentMethodCheckDTO} duplicatePaymentMethodCheckDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function duplicatePaymentMethodCheck(
    id: string,
    duplicatePaymentMethodCheckDTO: DuplicatePaymentMethodCheckDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<IsDuplicateResponse> {
    const localVarAxiosArgs = OrdersApiAxiosParamCreator(configuration).duplicatePaymentMethodCheck(id, duplicatePaymentMethodCheckDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Gets the amount remaining on an order
 * @param {string} id Order id
 * @param {boolean} includeInterest 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function getAmountRemaining(
    id: string,
    includeInterest: boolean,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<OrderAmountRemainingDTO> {
    const localVarAxiosArgs = OrdersApiAxiosParamCreator(configuration).getAmountRemaining(id, includeInterest, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

